// Custom Components
import http from "helpers/http/http.helper";

// GET SUBSCRIPTIONS
export const SUBSCRIPTIONS_LOADING = "SUBSCRIPTIONS_LOADING";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const SUBSCRIPTIONS_ERRORS = "SUBSCRIPTIONS_ERRORS";

// ADD SUBSCRIPTION
export const SUBSCRIPTION_ADD_LOADING = "SUBSCRIPTION_ADD_LOADING";
export const ADD_SUBSCRIPTION = "ADD_SUBSCRIPTION";
export const SUBSCRIPTION_ADD_ERROR = "SUBSCRIPTION_ADD_ERROR";

// DELETE SUBSCRIPTION
export const SUBSCRIPTION_DELETE_LOADING = "SUBSCRIPTION_DELETE_LOADING";
export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
export const SUBSCRIPTION_DELETE_ERROR = "SUBSCRIPTION_DELETE_ERROR";

// SUBSCRIPTIONS
export const getSubscriptionHistory = (id) => async dispatch => {
  try {
    dispatch({
      type: SUBSCRIPTIONS_LOADING,
      payload: true
    });
    const response = await http().get(`/subscriptions/${id}`);
    dispatch({
      type: GET_SUBSCRIPTIONS,
      payload: response.data
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      return (window.location.href = "/");
    }
    dispatch({
      type: SUBSCRIPTIONS_ERRORS,
      payload: error?.response?.data?.errors || error
    });
  } finally {
    dispatch({
      type: SUBSCRIPTIONS_LOADING,
      payload: false
    });
  }
};

export const deleteSubscription = (id) => async dispatch => {
  try {
    dispatch({
      type: SUBSCRIPTION_DELETE_LOADING,
      payload: true
    });
    const response = await http().put(`/subscriptions/${id}/delete`);
    dispatch({
      type: DELETE_SUBSCRIPTION,
      payload: response.data
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      return (window.location.href = "/");
    }
    dispatch({
      type: SUBSCRIPTION_DELETE_ERROR,
      payload: error?.response?.data?.errors || error
    });
  } finally {
    dispatch({
      type: SUBSCRIPTION_DELETE_LOADING,
      payload: false
    });
  }
};

export const addSubscription = postData => async dispatch => {
  try {
    dispatch({
      type: SUBSCRIPTION_ADD_LOADING,
      payload: true
    });
    const finalPostData = {
      ...postData
    };
    if (!finalPostData?.plan?.id && !finalPostData?.plan) {
      throw new Error("Plan is required");
    }
    finalPostData.plan = finalPostData.plan?.id ?? finalPostData.plan;
    if (finalPostData.currency) {
      finalPostData.currency =
        finalPostData.currency?.id ?? finalPostData.currency;
    }
    if (finalPostData.subscription_status) {
      finalPostData.subscription_status =
        finalPostData.subscription_status?.id ?? finalPostData.subscription_status;
    }
    if (finalPostData.payment_mode) {
      finalPostData.payment_mode =
        finalPostData.payment_mode?.id ?? finalPostData.payment_mode;
    }

    Object.keys(finalPostData).forEach(key => {
      const value = finalPostData[key];
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "object" &&
          value !== null &&
          !Array.isArray(value) &&
          !Object.keys(value).length)
      ) {
        delete finalPostData[key];
      }
    });

    const response = await http().post("/subscriptions", finalPostData);
    dispatch({
      type: ADD_SUBSCRIPTION,
      payload: response.data
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      return (window.location.href = "/");
    }
    const payload = error?.response?.data?.errors || [
      { message: error?.message || "Failed to create subscription" }
    ];
    dispatch({
      type: SUBSCRIPTION_ADD_ERROR,
      payload
    });
  } finally {
    dispatch({
      type: SUBSCRIPTION_ADD_LOADING,
      payload: false
    });
  }
};
